(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"]) return;
  try {
    

window.addEventListener('load', function () {

  var button = document.getElementById("popup-x");
  var modal = document.querySelector(".shopify-section-group-popup-group");

  // Show the modal when the button is clicked
  button.addEventListener("click", function() {
      modal.style.display = "none";
  });

});

  } catch(e) { console.error(e); }
})();
})();
